import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["perfumedCandle", "variant"]
  static values = {
    variants: Array
  }

  connect() {
    // If a variant is already selected but no candle is selected,
    // we need to find and select the candle first
    const currentVariantId = parseInt(this.variantTarget.value)
    const perfumedCandleId = parseInt(this.perfumedCandleTarget.value)

    if (currentVariantId && !perfumedCandleId) {
      // Find the candle for this variant
      const variant = this.variantsValue.find(v => v.id === currentVariantId)
      if (variant) {
        this.perfumedCandleTarget.value = variant.perfumed_candle_id
      }
    }

    this.updateVariants()
  }

  updateVariants() {
    const perfumedCandleId = parseInt(this.perfumedCandleTarget.value)
    const variantSelect = this.variantTarget
    const currentVariantId = variantSelect.value

    // Clear current options
    variantSelect.innerHTML = '<option value="">Select a variant</option>'

    if (!perfumedCandleId) {
      variantSelect.disabled = true
      return
    }

    // Filter variants for selected perfumed candle
    const filteredVariants = this.variantsValue.filter(v => v.perfumed_candle_id === perfumedCandleId)

    if (filteredVariants.length === 0) {
      variantSelect.disabled = true
      const option = document.createElement('option')
      option.value = ''
      option.textContent = 'No variants available'
      variantSelect.appendChild(option)
      return
    }

    // Add filtered variants
    let hasSelectedVariant = false
    let favoriteVariant = null
    filteredVariants.forEach((variant, index) => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.display_name
      if (variant.id === parseInt(currentVariantId)) {
        option.selected = true
        hasSelectedVariant = true
      }
      // Track the favorite variant
      if (variant.favorite) {
        favoriteVariant = variant
      }
      variantSelect.appendChild(option)
    })

    // If no variant was selected and we have variants, select the favorite or the first one
    if (!hasSelectedVariant && filteredVariants.length > 0) {
      if (currentVariantId) {
        variantSelect.value = currentVariantId
      } else if (favoriteVariant) {
        // Pre-select the favorite variant
        variantSelect.value = favoriteVariant.id
      }
    }

    variantSelect.disabled = false
  }
}

